import {useRef} from "react";
import classNames from "classnames";
import {HeaderTop} from "./HeaderTop/HeaderTop";
import {HeaderMain} from "./HeaderMain/HeaderMain";
import {CountryOption} from "@/entities/country";
import {User} from "@/entities/user";
import {useScrollDirection} from "@/features/header";
import {useCatalogMenu} from "@/widgets/catalog-menu";
import styles from "./Header.module.scss";

type Props = {
    hideHeader: boolean;
    authCheck: boolean;
    user: User;
    countryList: CountryOption[];
    imgVersion: string;
    catalogMenu: string[];
}

export const Header = (
    {
        hideHeader = false,
        authCheck = false,
        user,
        countryList = [],
        imgVersion = '',
        catalogMenu = []
    }: Props
) => {
    const headerRef = useRef(null);

    const {scrollY, scrollDirection} = useScrollDirection();

    const catalogMenuDrawer = useCatalogMenu();

    const headerClasses = classNames(styles.header, {
        [styles.catalogMenuOpened]: catalogMenuDrawer.opened,
        [styles.scrollUp]: scrollDirection === "up",
        [styles.scrollDown]: scrollDirection === "down",
    });

    const emptyClasses = classNames(
        styles.empty,
        {
            [styles.visible]: scrollY > 120,
        }
    );

    if (hideHeader) return null;

    return (
        <header ref={headerRef} id={`header`} className={headerClasses}>
            <div className={emptyClasses}></div>
            <HeaderTop countryList={countryList} />
            <HeaderMain authCheck={authCheck} user={user} imgVersion={imgVersion} catalogMenu={catalogMenu} />
        </header>
    );
}
